import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { DocumentStatusesCountResponse, DocumentStatusesInitials } from './_clientTypes';
import axios from "axios";
import { handleAxiosError } from '../../axios/handleAxiosError';
import { handleError } from '../../utils/handleError';
import { ODataParams } from '../_ODataTypes';
import { buildApiUrl } from '../../axios/urlCreator';
import { cachedGet } from '../../axios/responseCache';

const initialState: DocumentStatusesInitials = {
    documentStatuses: null,
    loading: false,
    error: null
};

export const getDocumentStatusesCount = createAsyncThunk<DocumentStatusesCountResponse, ODataParams | void>(
    'client/getDocumentStatusesCount',
    async (params, { rejectWithValue }) => {
        try {
            const queryParams = new URLSearchParams();
            if (params?.filter) queryParams.append('$filter', params.filter);
            if (params?.orderby) queryParams.append('$orderby', params.orderby);
            if (params?.top != null) queryParams.append('$top', params.top.toString());
            if (params?.skip != null) queryParams.append('$skip', params.skip.toString());

            return await cachedGet<DocumentStatusesCountResponse>(buildApiUrl("client/documentStatusesCount", queryParams), 30_000);
        }
        catch (error) {
            if (axios.isAxiosError(error)) {
                return rejectWithValue(handleAxiosError(error));
            }
            return rejectWithValue(handleError(error));
        }
    }
);

const documentStatusesSlice = createSlice({
    name: 'documentStatuses',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(getDocumentStatusesCount.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(getDocumentStatusesCount.fulfilled, (state, action) => {
                state.loading = false;
                state.error = null;
                state.documentStatuses = action.payload;
            })
            .addCase(getDocumentStatusesCount.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload as string;
            })
    }
});

export default documentStatusesSlice.reducer;
